<template lang="html">
  <div class="productos">
    <section class="middle-intro row-start">
      <div class="container">
        <h2 class="title -intro">{{ $t("features_list.titleProduct") }}</h2>
        <img src="/static/img/gifs/features-head.gif" class="imagen-animacion" alt="imagen animación" />
      </div>
    </section>

    <section>
      <div class="features-arriba container">
        <div class="texto">
          <h1 class="title -intro features">
            {{ $t("features_list.subtitle") }}
          </h1>
        </div>
        <div :class="[
          showFeatureAll
            ? 'boton-features-div'
            : 'boton-features-div inactive'
        ]">
          <template v-if="showFeatureAll">
            <p class="title -intro features contraer">Contraer todo</p>
          </template>
          <template v-else>
            <p class="title -intro features contraer">Expandir todo</p>
          </template>
          <div class="boton-azul" @click="toggleFeature">
            <div class="boton-circulo"></div>
          </div>
        </div>
      </div>

      <div class="producto-desc feature row-between">
        <div :dataFeature1="dataFeature1" :class="[showFeatureAll ? 'feature' : 'feature inactive']">
          <div class="cabecera-feature" @click="toggleThisFeature1">
            <div class="container">
              <h3 class="title feature">Iformalia (Módulo Core)</h3>
              <img src="/static/img/boton-cerrar.png" alt="boton cerrar" />
            </div>
          </div>
          <div class="contenido-features container">
           
            <p>
              Iformalia, una <strong>solución líder en el mercado</strong>, con
              más de 15 años de trayectoria en España, tanto en el área pública
              como privada, facilita y automatiza procesos</strong> y tareas para
              simplificar y aumentar la calidad de la gestión del talento en las
              empresas.
            </p>
            <p>
              La
              <strong>alta cualificación y especialización de nuestro equipo</strong>
              para gestión de
              formación y su especialización en el cumplimiento normativo de la
              Formación Bonificada y Planes Estatales y Autonómicos, es uno de
              los principales objetivos de la mejora continua y pieza clave en
              nuestra estrategia de diferenciación.
            </p>
            <div class="table-core">
              <div>
                <p>
                  Catálogo de Formación e Itinerarios: por perfil, área,
                  empresa, planes de bienvenida, formación asociada al puesto,
                  centro de trabajo, etc…
                </p>
              </div>
              <div>
                <p>
                  Detección de Necesidades: desde el envío del propio mail,
                  formulario de peticiones de formación no planificadas, nº de
                  participantes y fechas aprox, trazabilidad y seguimiento de
                  peticiones.
                </p>
              </div>
              <div>
                <p>
                  Gestión de la Oferta formativa y Solicitudes: Publicacion en la web,
                  portal o intranet de la oferta formativa. Gestión de
                  solicitudes por el responsable.
                </p>
              </div>
              <div>
                <p>
                  Gestión de Cursos, generación de Calendarios automática,
                  búsqueda y asignación a proveedores recursos (aulas,
                  materiales, profesores, etc..), Inscripciones masivas, control
                  asistencial.
                </p>
              </div>
              <div>
                <p>
                  Gestión de Comunicaciones a FUNDAE: Entrega de los XMLs y
                  avisos de las plazos que vencen.
                </p>
              </div>
              <div>
                <p>
                  Generador de Cuestionarios: Formatos por Móvil, PC,
                  Telefónicos, para realización de cuestionarios de
                  satisfacción a: responsables, medición de objetivos en el
                  puesto de trabajo, etc…
                </p>
              </div>
            </div>
            <p>
              <strong>Garantía de Calidad</strong>: Iformalia dispone de los
              sellos que certifican la gestión de la calidad (9.001), seguridad
              informática (27.000), gestión medioambiental (14.000) y calidad de
              gestión del servicio (20.000).
            </p>
            <div class="certificados">
              <img src="/static/img/certificados/certi1.jpg" alt="certificado" class="w-100 h-100" />
              <img src="/static/img/certificados/certi2.jpg" alt="certificado" class="w-100 h-100" />
              <img src="/static/img/certificados/certi3.jpg" alt="certificado" class="w-100 h-100" />
              <img src="/static/img/certificados/certi4.jpg" alt="certificado" class="w-100 h-100" />
            </div>
          </div>
        </div>

        <div id="firma-digitalizada" :dataFeature4="dataFeature4" class="feature "
          :class="[showFeatureAll ? 'feature' : 'feature inactive']">
          <div class="cabecera-feature" @click="toggleThisFeature4">
            <div class="container">
              <h3 class="title feature">
                Firma y control de presencia digital para la formación privada y FUNDAE
              </h3>

              <img src="/static/img/boton-cerrar.png" alt="boton cerrar" />
            </div>
          </div>
          <div class="contenido-features container">
            <div class="texto" v-html="$t('features_list.productos.firma_digitalizada.description')
              "></div>
            
          </div>

        </div>

        <div :dataFeature3="dataFeature3" :class="[showFeatureAll ? 'feature' : 'feature inactive']">
          <div class="cabecera-feature" @click="toggleThisFeature3">
            <div class="container">
              <h3 class="title feature">Gestor de Aulas Virtuales</h3>
              <img src="/static/img/boton-cerrar.png" alt="boton cerrar" />
            </div>
          </div>
          <div class="contenido-features container">
            <p>
              A raíz de la crisis generada por el Coronavirus, una de las medidas más importantes que se han establecido
              es la prohibición de la formación presencial, lo cual obliga a buscar alternativas y a prepararse para
              futuras medidas de normalización que modificarán con seguridad la formación presencial en periodos de riesgo
              en los próximos cursos.
            </p>
            <p>
              Innopulse, además del sistema de gestión iformalia, ofrece un orquestador de Aulas Virtuales que permite
              automatizar la convocatoria, creación de sesiones, control de asistencia y procesos de dinamización
              automáticos.
            </p>
            <p>
              Nuestro sistema organiza y asigna automáticamente las sesiones en el sistema de aula virtual elegido (Teams,
              Zoom, Connect, etc..) según disponibilidad y control del máximo de alumnos, aulas disponibles, etc…
            </p>

            <p>
              Además el sistema permite capturar la firma digitalizada biométrica o con Certificado electrónico y
              garantiza la autenticidad de los datos correspondientes de la misma y la identidad de las personas firmantes
              (Ampliacion de Garantías y Seguridad).
            </p>

            <p>
              <br>LA SOLUCIÓN PERFECTA PARA EJECUTAR FORMACION EN AULA VIRTUAL DE MANERA AUTOMATIZADA, ELIMINAR EL PAPEL Y
              REALIZAR UN SEGUIMIENTO PROACTIVO DE LA ASISTENCIA DE LOS ALUMNOS A LOS CURSOS DE FORMACIÓN EN AULAS
              VIRTUALES<br><br><strong>OPERATIVA</strong><br>
            </p>

            <p>
              El gestor únicamente planificará las sesiones presenciales de sus cursos (en el futuro cuando el aula
              virtual sea una modalidad, solo las sesiones de aula virtual).
            </p>

            <p>
              Nuestra API, bien por Web Services o por intercambio de EXCEL (Entrada y Salida) recoge las planificaciones
              y asistentes y crea automáticamente las sesiones de cada curso en el aula virtual (Teams, Connect, Zoom,
              WebEx, etc..).
            </p>

            <p>
              Nuestro sistema inscribe automáticamente al Formador, participantes y usuario SEPE en la sesión
              correspondiente.
            </p>
            <p>
              Avisará 15 min antes con un mail que incluye el link de acceso securizado e individual (identifica al
              participante por email, Nombre, Apellidos y NIF) para cada participante (sin necesidad de USR o PWD) y al
              Formador (y gestor), enviándoles un acceso al panel de seguimiento.
            </p>

            <p>
              Tras la finalización calcula el % de asistencia a incrementar en el grupo (valida si se alcanza el 75% al
              finalizar el curso) y guarda una copia de seguridad del LOG de conexiones del aula virtual.
            </p>

            <p>
              Remite al ERP o devuelve en la carpeta de intercambio del Excel, el Excel de salida con las asistencias,
              fechas y horas de entrada y salida, y resto de datos de auditoría SEPE, además de los PDFs firmados
              (asistencia, recibís, declaración responsable, etc…opcional).<br><br><strong>PROCESO</strong><br>
            </p>

            <p>
              Diariamente se envía al gestor del curso un mail con el estado de sus aulas virtuales y las tareas
              pendientes, donde podrá visualizar si la planificación es correcta y el histórico de firmas y registros de
              asistencia de aulas virtuales realizadas son correctas
            </p>

            <p>
              En el Acceso de auditoría se podrán encontrar todas las sesiones del curso, y en cada una de ellas se podrá
              encontrar:<br>
            <ul>
              <li>Los acceso de cada participante:<br>Fecha y Hora entrada<br>Fecha y Hora salida</li>
              <li>Expediente, Acción formativa y Grupo</li>
              <li>Nº de sesión</li>
              <li>Fecha y Hora Inicio Sesión</li>
              <li>Nombre</li>
              <li>Apellidos del alumno</li>
              <li>NIF</li>
              <li>Tiempo conectado</li>
              <li>IP</li>
              <li>Firma del formador</li>
              <li>Link de descarga del PDF</li>
            </ul>
            </p>
            <div class="imagenfeature animate row-start">
              <img src="/static/img/aula-virtual4.png" alt="aula virtual" />
            </div>
          </div>

        </div>

        <div :dataFeature5="dataFeature5" :class="[showFeatureAll ? 'feature' : 'feature inactive']">
          <div class="cabecera-feature" @click="toggleThisFeature5">
            <div class="container">
              <h3 class="title feature">
                Detección de Necesidades de Formación
              </h3>
              <img src="/static/img/boton-cerrar.png" alt="boton cerrar" />
            </div>
          </div>
          <div class="contenido-features container">
            <p>
              <strong>El objetivo del DNF es la elaboración de un buen plan de
                formación integral</strong>, así como la gestión de solicitudes de cursos existentes o no en
              el catálogo de acciones formativas de la empresa.
              <strong>En todo momento conoceremos y daremos respuesta a las
                necesidades formativas de la organización</strong>.
            </p>

            <p>
              El módulo DNF y las acciones formativas o plan de formación
              estarán en consonancia a las necesidades de la organización y
              alineado a los objetivos del negocio, posicionando al dpto. de
              formación como unidad estratégica en la compañía.
            </p>
            <p>
              <strong>Identificaremos formaciones transversales por rol y funciones
                dentro de las áreas, optimizando costes y tiempos</strong>
              en el despliegue, eliminando peticiones aisladas de formación que
              no se alinean con el plan y objetivos del negocio.
            </p>
            <p>
              El módulo DNF de Innopulse
              <strong>ofrece un portal y punto de encuentro</strong>
              entre empleados, managers y técnicos de formación de la
              organización para ser capaces de realizar un diagnóstico de
              necesidades formativas eficiente. Para obtener resultados hay que
              saber dónde enfocar los esfuerzos y si no disponemos de la
              información, es muy probable que el plan fracase.
            </p>
            <p>
              En definitiva,
              <strong>el módulo DNF de iformalia nos permitirá realizar un buen
                diagnóstico de las necesidades formativas de la
                organización</strong>
              para a partir de ahí, realizar un buen tratamiento. Siempre de una
              manera sencilla y trasparente para los distintos actores del
              proceso.
            </p>
            <p>
              <strong>Iformalia permitirá que las decisiones de acciones formativas a
                ejecutar o del propio Plan de Formación se base en datos, no en
                evaluaciones cualitativas o solicitudes subjetivas.</strong>
              Esos datos serán los que impacten en el desempeño y en el negocio,
              que previamente habrán de ser correctamente identificados y
              ponderados. Y esa información, estará a disposición de los
              decisores casi en tiempo real y con actualizaciones constantes.
            </p>
          </div>
        </div>

        <!--         <div :dataFeature2="dataFeature2" :class="[showFeatureAll ? 'feature' : 'feature inactive']">
          <div class="cabecera-feature" @click="toggleThisFeature2">
            <div class="container">
              <h3 class="title feature">LMS (Plataforma elearning)</h3>
              <img src="/static/img/boton-cerrar.png" alt="boton cerrar" />
            </div>
          </div>
          <div class="contenido-features container">
            <div class="texto">
              <p>
                <strong>Campus Iformalia es una solución SaaS en cloud, completa e
                  integral para la gestión y ejecución de entornos de
                  aprendizaje formal, informal y extendido</strong>; supone un sistema 360 para la ejecución de formación
                online y
                mobile learning, gestión de contenidos de proveedores,
                biblioteca de contenidos multimedia y recursos y comunidades de
                conocimiento y componentes para aprendizaje no formal y
                extendido.
              </p>

              <p>
                Cada Usuario/Alumno accederá a su Campus teniendo un control
                absoluto sobre el desarrollo de su formación, pudiendo
                visualizar el último curso en el que se quedó y el punto exacto
                en el que lo dejó, fomentando así la continuación del
                aprendizaje.
              </p>
              <p>
                <strong>La plataforma permitirá contenido en diferentes
                  formatos</strong>
                como video, documentos, presentaciones, etc.
              </p>
              <p>
                La herramienta es <strong>Responsive 100%</strong>, garantizando
                el acceso desde cualquier dispositivo a las funcionalidades del
                sistema.
              </p>
            </div>
            <div class="imagenfeature animate row-start">
              <img src="/static/img/respons.jpg" alt="respons" />
            </div>
          </div>
        </div> -->

        <div :dataFeature2="dataFeature2" :class="[showFeatureAll ? 'feature' : 'feature inactive']">
          <div class="cabecera-feature" @click="toggleThisFeature2">
            <div class="container">
              <h3 class="title feature">Gestión académica</h3>
              <img src="/static/img/boton-cerrar.png" alt="boton cerrar" />
            </div>
          </div>
          <div class="contenido-features container">
            <div class="texto">
              <p>
                <strong>Logística y Reserva de aulas</strong>
              </p>

              <p>
                Módulo de gestión de centros, aulas, recursos y materiales para la ejecución de la formación. Facilita la
                realización de peticiones de materiales, recursos, necesidad de aula o plataforma y formador, al área de
                aprovisionamiento, compras o logística de manera semi automática, manteniendo informado en todo momento al
                área de Formación sobre el estado de las provisiones del curso.
              </p>
              <p>
                De manera visual y sencilla podremos ver la disponibilidad y grado de utilización de los distintos
                recursos necesarios para la impartición de la formación.
              </p>
              <br><br>
              <p>
                <strong>Itinerarios y formación recurrente</strong>
              </p>
              <p>Módulo que permite la gestión de planes de formación, cursos recurrentes o itinerarios formativos
                preestablecidos en la organización. Reflejará los distintos “caminos” formativos con los cursos que lo
                componen para tras asignarlo a los empleados o alumnos correspondientes, realizar el seguimiento de su
                realización. </p>
              <br><br>
              <p>
                <strong>Oferta formativa</strong>
              </p>
              <p>Módulo especializado para departamentos de formación, en el que se pueden publicar los cursos y oferta
                formativa, por categorías, itinerarios, etc… en distintos canales (web, RRSS, intranet…) permitiendo la
                solicitud de participación. </p>
              <p>Tras la petición por parte del interesado en dicha formación, se realizará una gestión de
                preinscripciones, envío de mails, gestión documentación (ficheros) requeridos, workflow de aprobaciones o
                control de estados (preinscrito, rechazado, baja, confirmado, inscrito, etc..) </p>
              <br><br>
              <p>
                <strong>ChatbotIA para ayuda con la oferta de cursos y gestión de alumnos</strong>
              </p>
              <p>ChatBot IA Iformalia es un sistema de chat desarrollado en un modelo de lenguaje de IA y Machine Learning
                para ayudar a los técnicos de formación, alumnos o profesores en su desempeño diario. La aplicación es
                capaz de comprender a la perfección las palabras y de dar respuestas acordes y conversacionales. </p>
              <p>Sus principales funcionalidades se focalizan en ayudar u orientar a los técnicos de formación en la
                elaboración del Plan de formación y oferta formativa y en proponer a los alumnos o empleados las
                formaciones idóneas en base a sus intereses. </p>
              <br><br>
              <p>
                <strong>Control de costes y presupuestos</strong>
              </p>
              <p>Módulo que permite la Gestión del presupuesto y planificación del Plan de formación. Facilitará el
                registro de gastos y costes (materiales, proveedores, formadores, recursos, etc…) para su control y
                seguimiento. Así, podremos obtener una visión analítica del presupuesto y de sus costes asociados. </p>
            </div>
          </div>
        </div>

        <div :dataFeature6="dataFeature6" :class="[showFeatureAll ? 'feature' : 'feature inactive']">
          <div class="cabecera-feature" @click="toggleThisFeature6">
            <div class="container">
              <h3 class="title feature">Portal del alumno y empleado</h3>
              <img src="/static/img/boton-cerrar.png" alt="boton cerrar" />
            </div>
          </div>
          <div class="contenido-features container">
            <div class="texto">
              <p>
                Dentro del sistema Iformalia hay un módulo encargado de ser el punto de encuentro de la empresa con el
                alumno/empleado por lo que a materia formativa respecta.
                <br><br>El portal del alumno permite a los destinatarios del servicio o área de formación, acceder a un
                portal personalizado, en el que poder realizar el seguimiento de sus cursos, así como visualizar el
                itinerario sugerido en base a su perfil profesional, así como distintos bloques de gran utilidad para el
                seguimiento y avance en su formación.<br><br>

                El portal propone bloques de Agenda, para seguimiento del curso, una carpeta de documentación para
                descargar diplomas, etc.. Y subir los mismos firmados. Dispone de un acceso directo a las tutorías o
                tareas de los cursos registradas por sus tutores, acceso a cuestionarios de satisfacción y evaluaciones,
                etc…

                <br><br>

                El alumno podrá acceder a su histórico formativo, sus itinerarios, el estado de las acciones formativas y
                acciones pendientes de realizar.
                <br><br>
                Además, la herramienta permite ofrecer toda una serie de posibilidades:<br><br>
              <ul>
                <li>
                  Acceder a los cuestionarios y descarga de diploma.
                </li>
                <li>
                  Permite al alumno visualizar el estado de trámite o respuesta de consultas, o crear nuevas,
                  identificando el tipo de consulta, el curso o libre.
                </li>
                <li>
                  Permite al alumno registrar toda la información referente a su perfil.
                </li>
                <li>
                  La solución permite identificar las expectativas profesionales, categorizadas, de los alumnos, así como
                  conocer sus competencias personales.
                </li>
                <li>
                  El alumno registra un histórico de intereses profesionales, tanto en el tipo de puesto, como en el
                  sector del puesto que le interesa.
                </li>
                <li>
                  Calendario que agenda las formaciones en modo vista Día / Semana / Mes
                </li>
                <li>
                  El alumno podrá ver el estado de sus solicitudes y realizará búsquedas de manera sencilla.
                </li>
              </ul>
              <br><br>En definitiva, se trata de un Portal web (para PC, móviles y tablets) para el alumno, integrable en
              la intranet de cualqueir empresa que complementa el portal del Empleado, especializando el área de
              formación.

              </p>

            </div>
            <div class="imagenfeature animate row-start">
              <img src="/static/img/portal-alumno.png" alt="Integración Fundae" class="w-100 h-100" />
            </div>
          </div>
        </div>

        <div :dataFeature7="dataFeature7" :class="[showFeatureAll ? 'feature' : 'feature inactive']">
          <div class="cabecera-feature" @click="toggleThisFeature7">
            <div class="container">
              <h3 class="title feature">Reporting y KPIs</h3>
              <img src="/static/img/boton-cerrar.png" alt="boton cerrar" />
            </div>
          </div>
          <div class="contenido-features container">

            <p>
              Iformalia dispone de un módulo avanzado de Reporting y diseño de Dashborads basado en
              <strong>PowerBI</strong>, interconectando la información desde una BBDD de datos preparados
              (cálculos, dimensiones, relaciones, contadores, etc…) que se autogenera cada 2 horas, para ofrecer los
              indicadores diseñados para el seguimiento de cualquier capa de negocio
              (Ejecución Formación, Evolución Competencial, test de valoración de calidad, asistencia a clase, %
              finalización, informes económicos y de bonificación, etc…)
              <br><br>
              <strong>Power BI</strong> es un servicio de análisis empresarial de Microsoft, su objetivo es proporcionar
              visualizaciones interactivas y capacidades de Business Intelligence (BI) con una interfaz lo suficientemente
              simple como para que los usuarios gestores sin conocimientos técnicos o informáticos creen sus propios
              informes y paneles o dashboards.
              <br><br>Desde Iformalia se posibilita la definición de informes e indicadores clave (KPIs), que se
              autogenerarán en la BBDD de intercambio periódicamente, sirviendo como entrada automática a PowerBi, para la
              definición libre de ilimitados informes, gráficos, paneles, etc… sin necesidad de integración o
              correspondencia de datos.
              <br><br>Iformalia mediante sus módulos avanzados de reporting, en PowerBI permite por tanto:<br>
            <ul>
              <li>Desarrollar Panales de Mando y control basados en los KPIs del cliente.</li>
              <li>Facilitar la máxima autonomía al usuario de recursos humanos para la explotación de datos y seguimiento
                de indicadores</li>
              <li>Diseñar informes personalizados que den respuesta a necesidades específicas de un proceso, trabajando
                directamente con las mismas entidades de datos que en el módulo de gestión (Simplicidad para el usuario).
              </li>
              <li>Compartir los paneles de datos con aquellos usuarios clave que se precise.</li>
              <li>Consultar y explotar información de recursos humanos, generar automáticamente gráficos y estar integrado
                con herramientas ofimáticas (Word, Excel, PDF), permitiendo su envío por email o impresión.</li>
              <li>Planificar la ejecución de cualquier proceso desde la misma herramienta de reporting del sistema y sin
                necesidad de cruzar información de diferentes informes.</li>
              <li>Por supuesto, Iformalia dispone de Buscadores avanzados internos, para realizar búsquedas de empleados,
                managers, cursos, candidatos, etc…en base a criterios definibles por el usuario.</li>
              <li> Facilitar información de valor para el análisis y toma de decisiones a distintos</li>

            </ul>

            <br><br>
            Roles y segmentos de usuarios.

            <br><br>
            El sistema permite, la configuración de dashboard principales de gestión predefinidos, además de la
            combinación de los diferentes aspectos definidos en los módulos de datos, para la generación de informes
            personalizados.
            <br><br>
            El sistema permite el diseño de tipo de informes y gráficos, así como la suscripción y programación de envíos
            de informes configurados.
            <br><br>
            La información podrá ser explotada en formato Excel, o en modelos de informes que se generan
            autocumplimentados, según las las plantillas previamente definidas.
            <br><br>
            Además del sistema del módulo avanzado de Reporting y diseño de Dashborads basado en <strong>PowerBI</strong>,
            iformalia permite la exportación de informes desde todas y cada una de las pantallas de gestión, por lo que,
            se posibilita la explotación y tratamiento de la información registrada en todo momento a un solo click.
            <br><br>Por otro lado, el sistema presenta diferentes tipos de informes sugiere distintas acciones, en función
            del módulo y el proceso que gestiona.

            </p>
            <div class="imagenfeature animate row-start">
              <img src="/static/img/power-bi4.png" alt="Integración Fundae" class="w-100 h-100" />
            </div>
          </div>

        </div>

        <div :dataFeature8="dataFeature8" :class="[showFeatureAll ? 'feature' : 'feature inactive']">
          <div class="cabecera-feature" @click="toggleThisFeature8">
            <div class="container">
              <h3 class="title feature">CRM Comercial</h3>
              <img src="/static/img/boton-cerrar.png" alt="boton cerrar" />
            </div>
          </div>
          <div class="contenido-features container">
            <p>
              El módulo CRM de iformalia se refiere al
              <strong>conjunto de prácticas, estrategias de negocio y tecnologías
                enfocadas en la relación con el cliente</strong>.
            </p>
            <p>
              Nuestro módulo CRM almacena información de clientes actuales y
              potenciales – nombre, dirección, teléfono, etc –, y sus
              actividades y puntos de contacto con la empresa, incluyendo
              visitas a sitios, llamadas telefónicas, e-mails, entre otras
              interacciones. No obstante, la plataforma no es solo una lista de
              contactos elaborada: ella
              <strong>reúne e integra datos valiosos para preparar y actualizar al
                equipo comercial con información personal de los clientes,
                historial y preferencias de compras</strong>.
            </p>
            <p>
              El sistema nos permitirá
              <strong>rastrear activamente y administrar la información de los
                clientes</strong>, conectando al equipo
              <strong>desde cualquier dispositivo</strong>. Simplificaremos
              tareas repetitivas para poder hacer un acompañamiento de leads más
              efectivo.
            </p>
            <p>
              Encontraremos más leads, cerraremos más negocios, conservaremos
              más clientes…, en definitiva,
              <strong>creceremos notablemente de manera organizada</strong>. Y
              es que las conversaciones son siempre personales, relevantes y
              actualizadas, generando un importante aumento en la satisfacción
              del cliente.
            </p>
            <p>
              Iformalia dispone de un conjunto de funcionales destinadas a la
              gestión de propuestas, visitas, actividades, entidades y
              contactos.
            </p>
            <p>
              <strong>Los Módulos Funcionales que componen el sistema son</strong>:
            </p>
            <ul>
              <li>
                <p>Gestión de Propuestas comerciales.</p>
              </li>
              <li>
                <p>Gestión de parrillas de costes y productos.</p>
              </li>
              <li>
                <p>Gestión de Actividades (Visitas, Tareas, Llamadas, etc…).</p>
              </li>
              <li>
                <p>Gestión de Listados y añadir empresas a listado General.</p>
              </li>
              <li>
                <p>Gestión de Contactos, Documentos y Agenda.</p>
              </li>
              <li>
                <p>
                  Solicitar aprobación de propuestas a Controller/ADRG (o DFO si
                  procede) y tramitación Riesgos.
                </p>
              </li>
              <li>
                <p>Entregar propuesta al cliente y solicitar Grupos.</p>
              </li>
            </ul>
            <div class="imagenfeature animate row-start">
              <img src="/static/img/crm.png" alt="crm" />
            </div>
          </div>

        </div>

        <div :dataFeature9="dataFeature9" :class="[showFeatureAll ? 'feature' : 'feature inactive']">
          <div class="cabecera-feature" @click="toggleThisFeature9">
            <div class="container">
              <h3 class="title feature" v-html="$t('features_list.productos.integraciones.title')"></h3>

              <img src="/static/img/boton-cerrar.png" alt="boton cerrar" />
            </div>
          </div>
          <div class="contenido-features container">
            <div class="texto" v-html="$t('features_list.productos.integraciones.description')"></div>
            <div class="imagenfeature-cuatro animate row-start">
              <img src="/static/img/SAP.jpg" alt="SAP Success Factors" class="w-100 h-100" />
              <img src="/static/img/netex.jpg" alt="Integración Fundae" class="w-100 h-100" />
              <img src="/static/img/totara.jpg" alt="Integración Fundae" class="w-100 h-100" />
              <img src="/static/img/cornerstone.jpg" alt="Integración Fundae" class="w-100 h-100" />
            </div>
          </div>
        </div>

        <div :dataFeature10="dataFeature10" :class="[showFeatureAll ? 'feature' : 'feature inactive']">
          <div class="cabecera-feature" @click="toggleThisFeature10">
            <div class="container">
              <h3 class="title feature">Otras Aplicaciones desarrolladas</h3>
              <img src="/static/img/boton-cerrar.png" alt="boton cerrar" />
            </div>
          </div>
          <div class="contenido-features container otras-apps">

            <div class="logo-proyect">
              <div class="box-logo" @click="toggleContent">
                <img src="/static/img/correos.png" alt="correos" />
              </div>
              <div class="box-contenido">
                <strong>PROYECTO/APLICACIÓN:</strong>

                <ul>
                  <li>
                    DESCRIPCIÓN GENERAL DEL PROYECTO: Servicio Mobile Learning
                    basado en el desarrollo e implantación de una APP en las nuevas
                    PDAs para el personal de reparto, junto con el despliegue de una
                    solución integrada para la creación, distribución y control del
                    seguimiento de contenidos formativos e informativos que se
                    publiquen para su visionado desde la App
                  </li>

                  El sistema se integra con un cuadro de mandos PowerBI, al cual se
                  le da acceso a los usuarios del Campus y Gestores de Formación,
                  para consumir en tiempo real cualquier información que se registre
                  en el sistema.
                  <li>
                    EMPRESA U ORGANISMO: CORREOS<br></li>
                </ul>
                <div class="close-more-info" @click="CloseContent">
                  <img data-v-09056c64="" src="/static/img/boton-cerrar.png" alt="boton cerrar">
                </div>
              </div>
            </div>

            <div class="logo-proyect">
              <div class="box-logo" @click="toggleContent">
                <img src="/static/img/soib.png" alt="soib" />
              </div>
              <div class="box-contenido">
                <p style="width: 100%;">
                  <strong>PROYECTO/APLICACIÓN: Detección de necesidades de formación para
                    los demandantes de empleo
                  </strong>
                </p>
                <ul>

                  <li>
                    DESCRIPCIÓN GENERAL DEL PROYECTO: Desarrollo e implantación de
                    un portal web de formación y empleo y una app móvil para el
                    servicio de empleo de las Islas Baleares. Plataforma para que
                    los ciudadanos y técnicos de gestión en materia de empleo y
                    formación interactuen.
                  </li>
                  <li>
                    ÁREAS FUNCIONALES: 4 áreas: web (FrontOffice desde el que
                    interactúan los agentes externos, la App para dispositivos
                    móviles y tablets, el backoffice para la gestión interna y el
                    módulo central del sistema que da servicio a todos ellos.
                  </li>
                </ul>
                <div class="close-more-info" @click="CloseContent">
                  <img data-v-09056c64="" src="/static/img/boton-cerrar.png" alt="boton cerrar">
                </div>
              </div>
            </div>

            <div class="logo-proyect">
              <div class="box-logo" @click="toggleContent">
                <img src="/static/img/ucm.png" alt="ucm" />
              </div>
              <div class="box-contenido">
                <p style="width: 100%;">
                  <strong>PROYECTO/APLICACIÓN: Desarrollar un sistema de Detección de
                    Necesidades Formativas y su posterior aprobación y seguimiento
                  </strong>
                </p>
                <ul>

                  <li>
                    DESCRIPCIÓN GENERAL DEL PROYECTO: Servicio de análisis,
                    desarrollo, implantación y mantenimiento de una aplicación para
                    el apoyo a la gestión de propuestas de programas para formación
                    permanente en la UCM.
                  </li>
                  <li>
                    EMPRESA U ORGANISMO: UCM Universidad Complutense de Madrid.
                  </li>
                </ul>
                <div class="close-more-info" @click="CloseContent">
                  <img data-v-09056c64="" src="/static/img/boton-cerrar.png" alt="boton cerrar">
                </div>
              </div>
            </div>

            <div class="logo-proyect">
              <div class="box-logo" @click="toggleContent">
                <img src="/static/img/red.es.png" alt="red" />
              </div>
              <div class="box-contenido">
                <p style="width: 100%;">
                  <strong>PROYECTO/APLICACIÓN: Elaboración de materiales de comunicación
                    de tipo editorial y materiales de comunicación de tipo vídeo
                    animado.
                  </strong>
                </p>
                <ul>
                  <li>
                    DESCRIPCIÓN GENERAL DEL PROYECTO: Prestación de un servicio de
                    elaboración y producción de materiales de comunicación
                    vinculados a las distintas áreas del Programa Digital Future
                    Society que permitan su posterior difusión tanto entre los
                    actores implicados en el Programa como en la Sociedad en
                    general.
                  </li>
                  <li>EMPRESA U ORGANISMO: RED.ES</li>
                  <br><br>
                </ul>
                <div class="close-more-info" @click="CloseContent">
                  <img data-v-09056c64="" src="/static/img/boton-cerrar.png" alt="boton cerrar">
                </div>
              </div>
            </div>

            <div class="logo-proyect">
              <div class="box-logo" @click="toggleContent">
                <img src="/static/img/fremap.png" alt="fremap" />
              </div>
              <div class="box-contenido">
                <p style="width: 100%;">
                  <strong>PROYECTO/APLICACIÓN: Servicio de “hosting”y mantenimiento de
                    una plataforma(LMS).
                  </strong>
                </p>
                <ul>
                  <li>DESCRIPCIÓN GENERAL DEL PROYECTO: Servicio de “hosting”y mantenimiento de
                    una plataforma(LMS) personalizada para la gestión de la formación online, que consiste
                    en publicación y convocatoria de cursos online, envío de correos
                    de dinamización a los participantes de los mismos, seguimiento de
                    realización, superación y finalización, envío de encuestas y
                    exámenes, extracción de informes.

                    Informes de seguimiento de la formación. Análisis de las acciones
                    formativas y su aprovechamiento. Analítica descriptiva, predictiva
                    y aumentada.
                  <li>
                    EMPRESA U ORGANISMO: FREMAP</li>
                </ul>
                <div class="close-more-info" @click="CloseContent">
                  <img data-v-09056c64="" src="/static/img/boton-cerrar.png" alt="boton cerrar">
                </div>
              </div>
            </div>
            
            <div class="logo-proyect">
              <div class="box-logo">
                <img src="/static/img/adecco.png" alt="adecco" />
              </div>
            </div>

            <div class="logo-proyect">
              <div class="box-logo">
                <img src="/static/img/quiron.png" alt="quiron" />
              </div>
            </div>

            <div class="logo-proyect">
              <div class="box-logo">
                <img src="/static/img/randstad.png" alt="randstad" />
              </div>
            </div>

            <div class="logo-proyect">
              <div class="box-logo">
                <img src="/static/img/renfe.png" alt="renfe" />
              </div>
            </div>

            <div class="logo-proyect">
              <div class="box-logo">
                <img src="/static/img/seat.png" alt="seat" />
              </div>
            </div>

            <div class="logo-proyect">
              <div class="box-logo">
                <img src="/static/img/telefonica.png" alt="telefonica" />
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script lang="js">

import ProductosList from '@/components/parts/productos-list';

export default {
  name: 'productos',
  props: [],
  mounted() {
    if (window.location.search) {
      $("html,body").animate({
        scrollTop: $('html').find($('#' + window.location.search.substring(1))).offset().top + 100
      }, 1000)
    }

  },
  data() {
    return {
      showFeatureAll: true,
      dataFeature1: true,
      dataFeature2: true,
      dataFeature3: true,
      dataFeature4: true,
      dataFeature5: true,
      dataFeature6: true,
      dataFeature7: true,
      dataFeature8: true,
      dataFeature9: true,
      dataFeature10: true,
    }
  },
  methods: {

    toggleContent: function () {
      event.target.parentNode.parentNode.classList.toggle("active")
      event.target.parentNode.parentNode.querySelector('.box-contenido').classList.toggle("active")
    },
    CloseContent: function () {
      event.target.parentNode.parentNode.parentNode.querySelector('.box-contenido').classList.remove("active")
    },
    toggleFeature: function () {
      this.showFeatureAll = !this.showFeatureAll;
    },

    toggleThisFeature1: function () {
      $('.feature[datafeature1="true"]').toggleClass('inactive')

    },
    toggleThisFeature2: function () {
      $('.feature[datafeature2="true"]').toggleClass('inactive')

    },
    toggleThisFeature3: function () {
      $('.feature[datafeature3="true"]').toggleClass('inactive')

    },
    toggleThisFeature4: function () {
      $('.feature[datafeature4="true"]').toggleClass('inactive')

    },
    toggleThisFeature5: function () {
      $('.feature[datafeature5="true"]').toggleClass('inactive')

    },
    toggleThisFeature6: function () {
      $('.feature[datafeature6="true"]').toggleClass('inactive')

    },
    toggleThisFeature7: function () {
      $('.feature[datafeature7="true"]').toggleClass('inactive')

    },
    toggleThisFeature8: function () {
      $('.feature[datafeature8="true"]').toggleClass('inactive')

    },
    toggleThisFeature9: function () {
      $('.feature[datafeature9="true"]').toggleClass('inactive')

    },
    toggleThisFeature10: function () {
      $('.feature[datafeature10="true"]').toggleClass('inactive')

    },
  },
  components: {
    'productos-list': ProductosList
  }

}
</script>

<style scoped>
.middle-intro {
  margin-bottom: 200px;
}

.title {
  font-size: 36px;
  color: #3374b0;
  margin-bottom: 40px;
}

.title.-main {
  margin-bottom: 0;
}

.titleIntro {
  width: calc(100% - 485px);
}

.contenido-features p {
  text-align: left;
}

.contenido-features ol {
  padding-left: 20px;
}

.contenido-features ol li {
  list-style: decimal;
  padding: 5px 0;
}

.table-core {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  margin: 30px 0;
  justify-content: center;
}

.table-core div {
  width: 33.3%;
  padding: 40px;
  background: #3374b0;
  min-height: 263px;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
}

.table-core div p {
  text-align: center;
}

.table-core div:nth-child(2n) {
  background: #e1eaf2;
  color: #41566d;
}

.certificados {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: center;
  margin: 0 auto;
  margin-top: 20px;
}

.certificados img {
  max-width: 200px;
  width: 100%;
}

.contenido-features ul {
  padding-left: 20px;
  text-align: left;
  width: 100%;
}

.contenido-features ul li {
  list-style: disc;
  margin: 7px 0;
}

.logo-proyect {
  width: 50%;
  padding: 0 20px;
  margin-bottom: 40px;
  /* position: relative; */
}

.box-logo {
  width: 100%;
  margin-bottom: 20px;
  height: 110px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.box-logo img {
  max-width: 340px;
}

.box-contenido {
  height: 0;
  opacity: 0;
  padding-top: -20px;
  transition: padding 0.5s ease-out;
  position: relative;
  z-index: -1;
  background: white;
}

.box-contenido.active {
  padding-top: 10px;
  height: auto;
  opacity: 1;
  z-index: 2;
  position: relative;
  transition: padding 0.5s ease-out;
}

.close-more-info img {
  max-width: 30px;
  margin-top: 15px;
  cursor: pointer;
}

@media screen and (max-width: 1920px) {
  .middle-intro {
    margin-bottom: 110px;
  }
}

@media screen and (max-width: 1200px) {
  .table-core div {
    width: 50%;
    padding: 20px;
    min-height: 250px;
  }
}

@media screen and (max-width: 1000px) {
  .titleIntro {
    width: 100%;
  }

  .middle-intro {
    margin-bottom: 30px;
  }

  .certificados img {
    max-width: 40%;
    width: 100%;
  }
}

@media screen and (max-width: 750px) {
  .table-core div {
    width: 100%;
    padding: 20px;
    min-height: auto;
  }

  .logo-proyect {
    width: 100%;
  }

  .logo-proyect {
    margin-bottom: 10px;
  }
}</style>



// WEBPACK FOOTER //
// src/components/views/features.vue